"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.voteSignerAccount = exports.getVotes = exports.getPendingWithdrawals = exports.getAccountRegistrationStatus = exports.celoKit = void 0;
const contractkit_1 = require("@celo/contractkit");
const cache_1 = require("@ledgerhq/live-network/cache");
const live_env_1 = require("@ledgerhq/live-env");
let kit;
const celoKit = () => {
    if (!kit)
        kit = (0, contractkit_1.newKit)((0, live_env_1.getEnv)("API_CELO_NODE"));
    return kit;
};
exports.celoKit = celoKit;
/**
 * Fetch account registered status. To lock any Celo, account needs to be registered first
 */
const getAccountRegistrationStatus = (address) => __awaiter(void 0, void 0, void 0, function* () {
    const accounts = yield (0, exports.celoKit)().contracts.getAccounts();
    return yield accounts.isAccount(address);
});
exports.getAccountRegistrationStatus = getAccountRegistrationStatus;
/**
 * Fetch pending withdrawals, with an index
 */
const getPendingWithdrawals = (address) => __awaiter(void 0, void 0, void 0, function* () {
    const lockedGold = yield (0, exports.celoKit)().contracts.getLockedGold();
    const pendingWithdrawals = yield lockedGold.getPendingWithdrawals(address);
    const pendingWithdrawalsWithIndexes = pendingWithdrawals
        .map((withdrawal, index) => (Object.assign(Object.assign({}, withdrawal), { index })))
        .sort((a, b) => a.time.minus(b.time).toNumber());
    return pendingWithdrawalsWithIndexes;
});
exports.getPendingWithdrawals = getPendingWithdrawals;
/**
 * Fetch all votes
 */
const getVotes = (address) => __awaiter(void 0, void 0, void 0, function* () {
    const election = yield (0, exports.celoKit)().contracts.getElection();
    const voter = yield election.getVoter(yield (0, exports.voteSignerAccount)(address));
    const activates = yield getActivateTransactionObjects(address);
    const activatableValidatorGroups = activates.map(activate => activate.txo.arguments[0]);
    const votes = [];
    voter.votes.forEach(vote => {
        let activeVoteRevokable = true;
        if (vote.pending.gt(0)) {
            // If there's a pending vote, it has to be revoked first
            activeVoteRevokable = false;
            votes.push({
                validatorGroup: vote.group,
                amount: vote.pending,
                // Not all pending votes can be activated, 24h has to pass
                activatable: activatableValidatorGroups.includes(vote.group),
                revokable: true,
                index: 0,
                type: "pending",
            });
        }
        if (vote.active.gt(0))
            votes.push({
                validatorGroup: vote.group,
                amount: vote.active,
                activatable: false,
                revokable: activeVoteRevokable,
                index: 1,
                type: "active",
            });
    });
    return votes;
});
exports.getVotes = getVotes;
const getActivateTransactionObjects = (address) => __awaiter(void 0, void 0, void 0, function* () {
    const election = yield (0, exports.celoKit)().contracts.getElection();
    return yield election.activate(yield (0, exports.voteSignerAccount)(address));
});
/**
 * Fetch and cache address of a vote signer account
 * Cache it for 1h since vote signer is usually the same account as our address
 */
exports.voteSignerAccount = (0, cache_1.makeLRUCache)((address) => __awaiter(void 0, void 0, void 0, function* () {
    const accounts = yield (0, exports.celoKit)().contracts.getAccounts();
    return yield accounts.voteSignerToAccount(address);
}), address => address, {
    ttl: 60 * 60 * 1000, // 1 hour
});
//# sourceMappingURL=sdk.js.map